import { createElement, FC } from 'react';
import { SystemIcon } from 'legos/system-icon';
import { LinkBody } from 'legos/typography';
import { Cta, Helper, Chevron } from './respond-helper-link.ccm.css';

type LinkProps = Pick<JSX.IntrinsicElements['a'], 'href' | 'rel' | 'onClick'>;

interface RespondHelperLinkProps extends LinkProps {
  color: string;
  paddingVertical?: boolean;
  paddingHorizontal?: boolean;
}

const HelperLink = Helper.as(LinkBody);

export const RespondHelperLink: FC<RespondHelperLinkProps> = ({
  color,
  children,
  href,
  rel,
  onClick,
  paddingVertical = false,
  paddingHorizontal = false
}) => (
  <Cta.div $padding={paddingHorizontal}>
    <HelperLink
      color={color}
      href={href}
      rel={rel}
      onClick={onClick}
      $padding={paddingVertical}
    >
      {children}
      <Chevron.span>
        <SystemIcon type="chevronRight" color="primary" size={2} />
      </Chevron.span>
    </HelperLink>
  </Cta.div>
);
